<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase :title="definition?.label ?? 'Command'" icon="⌘" color="#0891b2">
        <template v-for="parameter in definition?.parameters ?? []" :key="parameter.id">
            <label>{{ parameter.label }}</label>
            <input
                type="text"
                :value="props.data.parameters?.[parameter.id] ?? ''"
                @input="updateParameter(parameter.id, $event.target.value)"
                :placeholder="parameter.scriptDefault ?? parameter.default ?? ''" />
        </template>
        <span v-if="!(definition?.parameters?.length)" class="text-gray-500">No options</span>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { computed } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import { getCommandDefinition } from '../../actions/commandRegistry.js';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const definition = computed(() => getCommandDefinition(props.data.commandId));

function updateParameter(parameterId, value) {
    updateNodeData(props.id, {
        ...props.data,
        parameters: { ...(props.data.parameters ?? {}), [parameterId]: value },
    });
}
</script>
